type StepperButtonProps = {
  onClick: () => void;
  icon: "plus" | "minus";
  disabled?: boolean;
};

export function StepperButton({ onClick, icon, disabled }: StepperButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-[15px] h-[15px] flex items-center justify-center shrink-0 aspect-square disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d={icon === "plus" ? "M4.5 2V7M2 4.5H7" : "M2 4.5H7"}
          stroke="var(--neutral-default,#5E5E5E)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
